import Text from 'components/shared/Text'
import { useIntl } from 'react-intl'
import Box from 'components/shared/Box'
import Input from 'components/shared/Input'
import { useAppSelector } from 'store/hooks'
import { useErrorMessages } from 'utils/hooks/useErrorMessages'
import { useDispatch } from 'react-redux'
import { setShippingInfo } from 'store/order-slice'
import useSignature from './useSignature'
import { useRef } from 'react'
import VoucherPreview from 'components/shared/VoucherPreview'
import { VoucherInfo } from './VoucherInfo'

const VALIDATION_ID = 'voucherSignature[0]'

const PersonalisedVoucher = () => {
    const { formatMessage } = useIntl()
    const dispatch = useDispatch()
    const { getError, handleRemoveError } = useErrorMessages()

    const { refundPrice } = useAppSelector((state) => state.selfcareCart)

    const handleSignatureBlur = (value: string[]) => {
        dispatch(setShippingInfo({ field: 'signature', value }))
    }

    const textareaRef = useRef<HTMLTextAreaElement>(null)

    const { value, signature, formatedSignature, handleChange } = useSignature()

    return (
        <Box>
            <Text variant="heading4" mb={[16, 24]} mt={[36, 40]}>
                {formatMessage({
                    id: 'selfcare.payment.personalize_voucher',
                    defaultMessage: 'Spersonalizuj voucher',
                })}
            </Text>
            <VoucherInfo />
            <Box isFullWidth direction={['column', 'row']} gap={[26, 16]}>
                <Box isFullWidth minWidth={[0, 310]}>
                    <Input
                        id={VALIDATION_ID}
                        type="textarea"
                        label={formatMessage({
                            id: 'selfcare.payment.personalize_voucher_label',
                            defaultMessage: 'Tekst na voucherze',
                        })}
                        infoMessage={formatMessage({
                            id: 'selfcare.payment.personalize_voucher_max_char',
                            defaultMessage:
                                'Maksymalnie 3 wiersze po 18 znaków',
                        })}
                        isRequired
                        onChange={(value) => {
                            handleRemoveError('voucherSignature')
                            handleChange(value)
                        }}
                        isError={!!getError(VALIDATION_ID)}
                        errorMessage={getError(VALIDATION_ID)}
                        onBlur={() => handleSignatureBlur(signature)}
                        value={value}
                        refToElement={textareaRef}
                        minHeight={134}
                        testId="payment-field-voucher-signature"
                    />
                </Box>
                <VoucherPreview
                    voucherSignature={formatedSignature}
                    unitPrice={refundPrice || 0}
                />
            </Box>
        </Box>
    )
}

export default PersonalisedVoucher
